export default {"src":"/_next/static/media/dryer.2941b92b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};